<template>
  <connexion-container session-type="client" :no-client="true">
    <h1 class="d-none">Inscrivez-vous</h1>
    <form class="access-form__form" @submit.prevent="signIn">
      <wizard @cancel="cancel" @submit="submit" :loading="loading" ref="signUpForm">
        <wizard-step title="Infos">
          <div class="form-row">
            <r-input v-model="params.last_name" name="nom" label="Nom" icon="user" class="col" :error="errors.last_name" />
            <r-input v-model="params.first_name" name="prénom" label="Prénom" icon="user-o" class="col" :error="errors.first_name" />
          </div>
          <r-input v-model="params.address" name="adresse" label="Adresse" icon="address-card-o" :error="errors.address" />
          <div class="form-row">
            <zc-input v-model="params.zip_code" class="col" :error="errors.zip_code" />
            <r-input v-model="params.city" name="ville" label="Ville" icon="map-o" class="col" :error="errors.city" />
          </div>
          <p-input v-model="params.phone" />
        </wizard-step>
        <wizard-step title="Identifiants">
          <r-input v-model="params.email" name="email" label="Email" icon="envelope-o" type="email" :error="errors.email" />
          <r-input v-model="params.password"
            vid="pConf"
            name="mot de passe"
            label="Mot de passe"
            icon="key"
            :type="password"
            placeholder="Min. 8 caractères"
            :rules="'min:8'"
            :error="errors.password">
            <i class="has-icon-right__icon fa fa-eye" @click.prevent="switchType('password')"></i>
          </r-input>
          <r-input v-model="params.password_confirmation"
            name="confirmation du mot de passe"
            label="Confirmer le mot de passe"
            icon="key"
            :type="passwordConfirmation"
            placeholder="Min. 8 caractères"
            :rules="'min:8|password:pConf'"
            :error="errors.password_confirmation">
            <i class="has-icon-right__icon fa fa-eye" @click.prevent="switchType('passwordConfirmation')"></i>
          </r-input>
        </wizard-step>
      </wizard>
    </form>
  </connexion-container>
</template>

<script>
import ConnexionContainer from '@/components/layout/ConnexionContainer'

export default {
  name: 'SignUp',
  components: {
    ConnexionContainer
  },
  data () {
    return {
      loading: false,
      params: {
        confirm_success_url: window.location.origin + '/client'
      },
      password: 'password',
      passwordConfirmation: 'password',
      errors: {}
    }
  },
  computed: {
    moveToError () {
      let errors = ['first_name', 'last_name', 'address', 'zip_code', 'city']
      if (_.intersection(_.keys(this.errors), errors).length) return 0
      else return 1
    }
  },
  created () {
    // handle redirect if session
  },
  methods: {
    cancel () {
      this.$router.push('sign_in')
    },
    switchType (type) {
      this[type] = this[type] === 'password' ? 'text' : 'password'
    },
    submit () {
      this.loading = true
      let params = {
        ...this.params,
        registered_for: this.$appName
      }
      this.$http.post('/client_auth', params).then(resp => {
        this.$store.commit(`SET_CLIENT_LOADED`, true)
        this.$store.commit('SET_CURRENT_CLIENT', resp.data.data)

        const authHeaders = _.pick(resp.headers, ['access-token', 'client', 'expiry', 'uid', 'session-type'])
        const contents = {
          tokens: authHeaders,
          id: resp.data.data.id,
          remember: this.remember
        }

        let expireDate = this.remember ? 14 : 1
        this.$cookie.set('client_session', JSON.stringify(contents), { expires: expireDate })
        this.loading = false
        this.$router.push({ name: 'clientDashboard' })
      }).catch(err => {
        this.loading = false
        this.errors = {}
        if (err.response.status === 422) {
          let e = err.response.data.errors
          this.errors = _.reduce(e, (result, value, key) => {
            result[key] = value[0]
            return result
          }, {})
          this.$refs.signUpForm.move(this.moveToError)
        }
      })
    }
  }
}
</script>
